import { render, staticRenderFns } from "./PermissionButtons.vue?vue&type=template&id=5e545823"
import script from "./PermissionButtons.vue?vue&type=script&lang=js"
export * from "./PermissionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports